"use client";

import { c as _c } from "react/compiler-runtime";
import type { AvailabilityFilter } from "@spree/sdk";
import { useTranslations } from "next-intl";
import { DropdownMenuRadioGroup, DropdownMenuRadioItem } from "@/components/ui/dropdown-menu";
import { getAvailabilityLabel } from "@/lib/utils/filters";
import { type AvailabilityStatus, isAvailabilityStatus } from "@/types/filters";
interface AvailabilityDropdownContentProps {
  filter: AvailabilityFilter;
  selected?: AvailabilityStatus;
  onChange: (value?: AvailabilityStatus) => void;
}
export function AvailabilityDropdownContent(t0) {
  const $ = _c(16);
  const {
    filter,
    selected,
    onChange
  } = t0;
  const t = useTranslations("products");
  const t1 = selected ?? "";
  let t2;
  if ($[0] !== onChange) {
    t2 = value => {
      if (!value || !isAvailabilityStatus(value)) {
        onChange(undefined);
      } else {
        onChange(value);
      }
    };
    $[0] = onChange;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t) {
    t3 = t("anyAvailability");
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <DropdownMenuRadioItem value="">{t3}</DropdownMenuRadioItem>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== filter.options || $[7] !== t) {
    let t6;
    if ($[9] !== t) {
      t6 = option => <DropdownMenuRadioItem key={option.id} value={option.id} onSelect={_temp}><span className="flex-1">{getAvailabilityLabel(option.id, t)}</span><span className="text-xs text-muted-foreground">({option.count})</span></DropdownMenuRadioItem>;
      $[9] = t;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    t5 = filter.options.map(t6);
    $[6] = filter.options;
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[11] !== t1 || $[12] !== t2 || $[13] !== t4 || $[14] !== t5) {
    t6 = <DropdownMenuRadioGroup value={t1} onValueChange={t2}>{t4}{t5}</DropdownMenuRadioGroup>;
    $[11] = t1;
    $[12] = t2;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}
function _temp(e) {
  return e.preventDefault();
}